import React, { forwardRef, memo } from 'react';

import cls from 'classnames';

import styles from './LinkButton.scss';

export type LinkButtonProps = React.PropsWithChildren<
  React.ComponentPropsWithoutRef<'button'> & {
    /** Дополнительные дата-локаторы */
    specificLocators?: string | string[];
  }
>;

const LinkButtonComponent = forwardRef<HTMLButtonElement, LinkButtonProps>((props, ref) => {
  const { className, type = 'button', specificLocators, children, ...forwardedProps } = props;

  return (
    <button
      className={cls(styles.root, className)}
      ref={ref}
      data-locator={specificLocators}
      // eslint-disable-next-line react/button-has-type
      type={type}
      /* eslint-disable react/jsx-props-no-spreading */
      {...forwardedProps}
    >
      {children}
    </button>
  );
});

export const LinkButton = memo(LinkButtonComponent);
